import React from "react";
import { Link, useLocation } from "react-router-dom";
import { LanguageSwitcher } from "../languageswitcher";
import "./style.css";

export const Navigation = () => {
  const location = useLocation();

  return (
    <header className="header-nav">
      <div className="header-content">
        <div className="nav-left">
          <Link to="/" className="nav-logo" aria-label="Rosota home">
            <img src="/image/rosota_logo.png" alt="Rosota" className="nav-logo-img" />
          </Link>
        </div>
        <nav className="nav-menu">
          <Link
            to="/"
            className={`nav-link ${location.pathname === '/' ? 'underline' : ''}`}
          >
            Vision
          </Link>
          <a
            href="https://www.rosota.ai/"
            className="nav-link nav-link--external"
            target="_blank"
            rel="noopener noreferrer"
          >
            Research
            <span className="nav-link-ext" aria-hidden="true">&#8599;</span>
          </a>
          <Link
            to="/about"
            className={`nav-link ${location.pathname === '/about' ? 'underline' : ''}`}
          >
            About us
          </Link>
          <Link
            to="/join"
            className={`nav-link ${location.pathname.startsWith('/join') ? 'underline' : ''}`}
          >
            Join us
          </Link>
        </nav>
        <div className="nav-right">
          <LanguageSwitcher />
        </div>
      </div>
    </header>
  );
};
